import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'

export const getQuestions = () => {
  switch (LOCALE) {
    case 'es-CO':
    case 'es-PR':
      return [
        {
          questions: '¿Qué es Pro-Defense V?',
          answer: (
            <p>
              Pro-Defense V es la nueva línea de productos Nosotras que protege
              la Zona V, que es una de las más delicadas del cuerpo. Esta nueva
              línea ayuda a cuidar y proteger el pH de tu zona íntima. Toda la
              línea Pro-Defense V contiene prebióticos (Inulina) ingrediente que
              conserva las defensas de tu zona V, manteniéndola en equilibrio.
            </p>
          ),
        },

        {
          questions:
            '¿Cuáles son las características principales de esta nueva línea?',
          answer: (
            <p>
              Toda la línea Pro-Defense V contiene Inulina, que es un prebiótico
              importante y el cual ayuda a conservar las defensas de tu Zona V,
              manteniéndola en equilibrio.
            </p>
          ),
        },

        {
          questions: '¿Es seguro usar estos nuevos productos?',
          answer: (
            <p>
              Claro que sí, la nueva línea Pro-Defense V está ginecológicamente
              testeada y dermatológicamente comprobada por médicos especialistas
            </p>
          ),
        },
        //         manteniéndola en equilibrio.
        //       </li>
        //     </p>
        //   ),
        // },

        {
          questions: '¿Por qué se altera la Zona V?',
          answer: (
            <p>
              Tu Zona V se encuentra expuesta a situaciones cotidianas que
              pueden afectarla, como el uso de ropa estrecha, el uso de baños
              públicos o incluso sentarnos en las máquinas del gimnasio. Estas
              situaciones conllevan muchas veces a que tu Zona V se altere.
            </p>
          ),
        },

        {
          questions:
            'Si tengo una infección o tengo mi pH alterado, ¿Pro-Defense sirve?\n',
          answer: (
            <p>
              Si tienes alguna alteración en el pH de tu vagina, es importante
              que busques ayuda médica, ya que la línea Pro-Defense V es un
              complemento de tu higiene intima, que te ayudará a conservar las
              defensas naturales de tu zona V, no es un medicamento. PARA USO
              EXTERNO SOLAMENTE.
            </p>
          ),
        },

        {
          questions: '¿La línea Pro Defense-V es un medicamento?',
          answer: (
            <p>
              Este producto es un complemento de tu higiene íntima, no es un
              MEDICAMENTO. PARA USO EXTERNO SOLAMENTE.
            </p>
          ),
        },

        {
          questions: 'Diferencias entre probióticos y prebióticos',
          answer: (
            <p>
              Los probióticos son las bacterias beneficiosas que viven en el
              cuerpo y mejoran el equilibrio de la piel. <br />
              Los prebióticos son componentes naturales que nutren a los
              probióticos (bacterias beneficiosas), para ayudar a mantener un pH
              saludable en pro de tu Zona V.
            </p>
          ),
        },

        {
          questions: '¿Por qué se usan los prebióticos?',
          answer: (
            <p>
              Se utilizan para ayudar a conservar las defensas de tu Zona V,
              manteniéndola en equilibrio.
            </p>
          ),
        },

        {
          questions:
            '¿Es necesario utilizar la línea completa en la rutina de higiene diaria?',
          answer: (
            <p>
              Para mejores resultados se recomienda el uso completo de la línea
              de productos Pro-Defense V. Se compone de protectores diarios,
              jabón íntimo y pañitos húmedos.{' '}
            </p>
          ),
        },

        {
          questions: '¿También hay Toallas Pro-Defense V?',
          answer: (
            <p>
              No, la línea Pro-Defense V se compone de protectores diarios,
              jabón íntimo y pañitos húmedos.
            </p>
          ),
        },

        {
          questions: '¿Cuántas veces al día debo cambiarme el protector?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con esta nueva tecnología, entienden la anatomía de las
              mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto? ',
          answer: (
            <p>
              Tanto las toallas plus como invisibles, están diseñadas para
              absorber flujo regular, y gracias a sus diferentes zonas tienen un
              mejor ajuste, previene derrames, brinda mayor flexibilidad y
              comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas y en todas las
              superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos y pruebas de
              laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions:
            '¿La actualización de estas toallas es mejor para el medio ambiente que la versión actual?',
          answer: (
            <p>
              En el proceso de fabricación de la toalla usamos una nueva
              tecnología que permite que tengamos menores desperdicios y
              optimizamos el uso de los materiales utilizados. Hay algunos
              productos con apuestas más sostenibles, como las toallas de
              algodón 100% orgánico o los panties reutilizables. ((Menos
              pigmentos en material de empaque, campañas de recolección de
              empaques, menor contaminación)) todo esto nos aporta sin
              sacrificar superioridad de producto
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?',
          answer: (
            <p>
              Hacé <a href="#shops">clic acá </a>, y podrás visualizar las
              tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]
    case 'es-AR':
    case 'es-UY':
      return [
        {
          questions: '¿Qué es Cur-V?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con esta nueva tecnología, entienden la anatomía de las
              mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto? ',
          answer: (
            <p>
              Tanto las toallas plus como invisibles, están diseñadas para
              absorber flujo regular, y gracias a sus diferentes zonas tienen un
              mejor ajuste, previene derrames, brinda mayor flexibilidad y
              comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas y en todas las
              superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos y pruebas de
              laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions:
            '¿La actualización de estas toallas es mejor para el medio ambiente que la versión actual?',
          answer: (
            <p>
              En el proceso de fabricación de la toalla usamos una nueva
              tecnología que permite que tengamos menores desperdicios y
              optimizamos el uso de los materiales utilizados. Hay algunos
              productos con apuestas más sostenibles, como las toallas de
              algodón 100% orgánico o los panties reutilizables. ((Menos
              pigmentos en material de empaque, campañas de recolección de
              empaques, menor contaminación)) todo esto nos aporta sin
              sacrificar superioridad de producto
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?',
          answer: (
            <p>
              Hacé <a href="#shops">clic acá </a>, y podrás visualizar las
              tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]
    case 'es-CL':
      return [
        {
          questions: '¿Qué es Pro-Defense V?',
          answer: (
            <p>
              Pro-Defense V es la nueva línea de productos Nosotras que protege
              la Zona V, que es una de las más delicadas del cuerpo. Esta nueva
              línea ayuda a cuidar y proteger el pH de tu zona íntima. Toda la
              línea Pro-Defense V contiene prebióticos (Inulina), ingrediente
              que conserva las defensas de tu zona V, manteniéndola en
              equilibrio.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva linea?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con la nueva tecnología Cur-V, entienden la anatomía de
              las mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estos nuevos productos?',
          answer: (
            <p>
              Claro que sí, la nueva línea Pro-Defense V está ginecológicamente
              testeada y dermatológicamente comprobada por médicos especialistas
            </p>
          ),
        },
        {
          questions: '¿Por qué se altera la Zona V?',
          answer: (
            <p>
              Tu Zona V se encuentra expuesta a situaciones cotidianas que
              pueden afectarla, como el uso de ropa estrecha, el uso de baños
              públicos o incluso sentarnos en las máquinas del gimnasio. Estas
              situaciones conllevan muchas veces a que tu Zona V se altere.
            </p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Esta tecnología esta en tus Toallas Ultra Invisibles (tela suave y
              tela malla) así como también en Sensiti-V (Tela suave). Sin
              embargo, en los productos noche todavía no podrás encontrarla
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos y pruebas de
              laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?',
          answer: (
            <p>
              Las puedes conseguir en el e-commerce de Jumbo, Cruz Verde,
              Salcobrand, Preunic y más. Haz <a href="#shops">clic aquí</a>, y
              podrás visualizar los logos de las tiendas donde encontrarás este
              nuevo producto.
            </p>
          ),
        },
      ]
    case 'es-PE':
      return [
        {
          questions: '¿Qué es Cur-V?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con la nueva tecnología Cur-V, entienden la anatomía de
              las mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto?',
          answer: (
            <p>
              Tanto las toallas plus como invisibles, están diseñadas para
              absorber flujo regular, y gracias a sus diferentes zonas tienen un
              mejor ajuste, previene derrames, brinda mayor flexibilidad y
              comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?\n',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas y en todas las
              superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos y pruebas de
              laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions:
            '¿La actualización de estas toallas es mejor para el medio ambiente que la versión actual?',
          answer: (
            <p>
              En el proceso de fabricación de la toalla usamos una nueva
              tecnología que permite que tengamos menores desperdicios y
              optimizamos el uso de los materiales utilizados. Hay algunos
              productos con apuestas más sostenibles, como las toallas de
              algodón 100% orgánico o los panties reutilizables. ((Menos
              pigmentos en material de empaque, campañas de recolección de
              empaques, menor contaminación)) todo esto nos aporta sin
              sacrificar superioridad de producto.
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?\n',
          answer: (
            <p>
              Las puedes conseguir en el e-commerce de Metro, Wong, Tottus,
              Plaza Vea, Inkafamra, Mifarma y más. Haz{' '}
              <a href="#shops">clic aquí</a>, y podrás visualizar los logos de
              las tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]
    case 'es-DO':
      return [
        {
          questions: '¿Qué es Cur-V?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con la nueva tecnología Cur-V, entienden la anatomía de
              las mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto?',
          answer: (
            <p>
              Tanto las toallas plus como invisibles, están diseñadas para
              absorber flujo regular, y gracias a sus diferentes zonas tienen un
              mejor ajuste, previene derrames, brinda mayor flexibilidad y
              comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?\n',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas y en todas las
              superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos y pruebas de
              laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions:
            '¿La actualización de estas toallas es mejor para el medio ambiente que la versión actual?',
          answer: (
            <p>
              En el proceso de fabricación de la toalla usamos una nueva
              tecnología que permite que tengamos menores desperdicios y
              optimizamos el uso de los materiales utilizados. Hay algunos
              productos con apuestas más sostenibles, como las toallas de
              algodón 100% orgánico o los panties reutilizables. ((Menos
              pigmentos en material de empaque, campañas de recolección de
              empaques, menor contaminación)) todo esto nos aporta sin
              sacrificar superioridad de producto.
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?\n',
          answer: (
            <p>
              Las puedes conseguir en el e-commerce de Farmacias Carol, La
              Sirena, Dream clean store y más. Haz{' '}
              <a href="#shops">clic aquí</a>, y podrás visualizar los logos de
              las tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]

    case 'es-EC':
      return [
        {
          questions: '¿Qué es Cur-V?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con la nueva tecnología Cur-V, entienden la anatomía de
              las mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto?',
          answer: (
            <p>
              Tanto las toallas plus como invisibles, están diseñadas para
              absorber flujo regular, y gracias a sus diferentes zonas tienen un
              mejor ajuste, previene derrames, brinda mayor flexibilidad y
              comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?\n',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas y en todas las
              superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos y pruebas de
              laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions:
            '¿La actualización de estas toallas es mejor para el medio ambiente que la versión actual?',
          answer: (
            <p>
              En el proceso de fabricación de la toalla usamos una nueva
              tecnología que permite que tengamos menores desperdicios y
              optimizamos el uso de los materiales utilizados. Hay algunos
              productos con apuestas más sostenibles, como las toallas de
              algodón 100% orgánico o los panties reutilizables. ((Menos
              pigmentos en material de empaque, campañas de recolección de
              empaques, menor contaminación)) todo esto nos aporta sin
              sacrificar superioridad de producto.
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?',
          answer: (
            <p>
              Las puedes conseguir en el e-commerce de frecuento.com, farmacias
              medicity, fybeca.com, TID y más. Haz{' '}
              <a href="#shops">clic aquí</a>, y podrás visualizar los logos de
              las tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]

    case 'es-BO':
      return [
        {
          questions: '¿Qué es Cur-V?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con la nueva tecnología Cur-V, entienden la anatomía de
              las mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto?',
          answer: (
            <p>
              Nuestras toallas están diseñadas para absorber flujo regular, y
              gracias a sus diferentes zonas tienen un mejor ajuste, previene
              derrames, brinda mayor flexibilidad y comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?\n',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas Diurnas y en todas
              las superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos Noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos, aval dermatológico
              y pruebas de laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?',
          answer: (
            <p>
              Las puedes conseguir en las tiendas autorizadas de e-commerce de
              Farmacorp, Hipermaxi y Pedidos Ya. Haz{' '}
              <a href="#shops">clic aquí</a>, y podrás visualizar los logos de
              las tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]
    case 'es-PY':
      return [
        {
          questions: '¿Qué es Cur-V?',
          answer: (
            <p>
              Cur-V es la nueva tecnología de toallas para el día, que te
              permitirá sentirte cómoda, segura y confiada en cada momento de tu
              vida social e íntima. En Nosotras entendemos a profundidad la
              anatomía íntima de la mujer y ofrecemos un nivel superior de
              cuidado en la Zona V con la nueva tecnología Cur-V.
            </p>
          ),
        },
        {
          questions:
            '¿Cuáles son las características principales de esta nueva toalla?',
          answer: (
            <p>
              ¡Mejoramos nuestras toallas para el día! Cur-V es la nueva
              generación de toallas higiénicas, pasando de una tecnología de
              ajuste seguro a una tecnología Cur-V. Las nuevas toallas diurnas
              Nosotras con la nueva tecnología Cur-V, entienden la anatomía de
              las mujeres y ahora vienen con 3 zonas de absorción inteligente,
              canales que distribuyen el flujo, alas asimétricas y mejor ajuste
              al cuerpo por las densidades de la toalla. Todo esto diseñado para
              que las mujeres puedan experimentar un nivel superior de
              flexibilidad, absorción y comodidad vs la anterior versión;
              brindándoles aún más seguridad y confianza.
            </p>
          ),
        },
        {
          questions: '¿Cuál es el nivel de absorción de este nuevo producto? ',
          answer: (
            <p>
              Nuestras toallas están diseñadas para absorber flujo regular, y
              gracias a sus diferentes zonas tienen un mejor ajuste, previene
              derrames, brinda mayor flexibilidad y comodidad.
            </p>
          ),
        },
        {
          questions: '¿Con qué frecuencia se deben cambiar estas toallas?',
          answer: (
            <p>Como se cambian habitualmente: uso recomendado cada 4 horas.</p>
          ),
        },
        {
          questions: '¿Cuáles son los beneficios de las alas asimétricas?',
          answer: (
            <p>
              ¡Es un descubrimiento maravilloso! Las alas, al ser asimétricas,
              no se traslapan y abrazan la ropa interior para mayor fijación,
              evitando accidentes.
            </p>
          ),
        },
        {
          questions: '¿Cuántas zonas de absorción tiene la toalla?',
          answer: (
            <p>
              La nueva toalla Cur-V cuenta con 3 zonas de absorción inteligente,
              estratégicamente ubicadas para mayor comodidad y seguridad.
            </p>
          ),
        },
        {
          questions:
            '¿Dónde están ubicadas las zonas de absorción de la toalla?',
          answer: (
            <p>
              Las zonas de absorción de la toalla Cur-V están ubicadas adelante,
              en el centro y atrás, para brindar total protección.
            </p>
          ),
        },
        {
          questions: '¿Esta tecnología solo la tiene Nosotras?',
          answer: (
            <p>Es correcto, solo Nosotras cuenta con esta nueva tecnología.</p>
          ),
        },
        {
          questions:
            '¿Puedo encontrar la tecnología Cur-V en todas las toallas?',
          answer: (
            <p>
              Sí, esta tecnología está en todas las toallas Diurnas y en todas
              las superficies que conoces: en la tipo tela y en la rapi sec. Sin
              embargo, en los productos Noche todavía no podrás encontrarla.
            </p>
          ),
        },
        {
          questions: '¿Es seguro usar estas toallas?',
          answer: (
            <p>
              Por supuesto que sí, tienen estudios clínicos, aval dermatológico
              y pruebas de laboratorio que avalan su desempeño.
            </p>
          ),
        },
        {
          questions: '¿Qué materiales tiene esta toalla?',
          answer: (
            <p>
              Son materiales de línea, con los cuales cumplimos los estudios de
              seguridad. Son telas tipo algodón y cubierta rapisec o malla.
            </p>
          ),
        },
        {
          questions: '¿Dónde puedo comprar estas toallas?',
          answer: (
            <p>
              Las puedes conseguir en las tiendas autorizadas de e-commerce de
              Farmacenter, Superseis, Stock Supermercados, Arete. Haz{' '}
              <a href="#shops">clic acá </a>, y podrás visualizar los logos de
              las tiendas donde encontrarás este nuevo producto.
            </p>
          ),
        },
      ]
  }
}
